var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Link Link-wrapper",on:{"click":_vm.onClick}},[_c('hempel-icon',{staticClass:"Link-icon",attrs:{"name":_vm.icon}}),_c('span',{staticClass:"Link-label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }